const geographyData = {
  "Afghanistan": {
    continent: "Asia",
    borders: ["Iran", "Pakistan", "Tajikistan", "Turkmenistan", "Uzbekistan", "China"]
  },

  "Albania": {
    continent: "Europe",
    borders: ["Greece", "Kosovo", "North Macedonia", "Montenegro"]
  },

  "Algeria": {
    continent: "Africa",
    borders: ["Libya", "Mali", "Mauritania", "Morocco", "Niger", "Tunisia", "Western Sahara"]
  },

  "Andorra": {
    continent: "Europe",
    borders: ["France", "Spain"]
  },

  "Angola": {
    continent: "Africa",
    borders: ["DR Congo", "Republic of the Congo", "Namibia", "Zambia"]
  },

  "Antigua and Barbuda": {
    continent: "North America",
    borders: []
  },

  "Argentina": {
    continent: "South America",
    borders: ["Bolivia", "Brazil", "Chile", "Paraguay", "Uruguay"]
  },

  "Armenia": {
    continent: "Asia",
    borders: ["Azerbaijan", "Georgia", "Iran", "Turkey"]
  },

  "Australia": {
    continent: "Oceania",
    borders: []
  },

  "Austria": {
    continent: "Europe",
    borders: ["Czech Republic", "Germany", "Hungary", "Italy", "Liechtenstein", "Slovakia", "Slovenia", "Switzerland"]
  },

  "Azerbaijan": {
    continent: "Asia",
    borders: ["Armenia", "Georgia", "Iran", "Russia", "Turkey"]
  },

  "Bangladesh": {
    continent: "Asia",
    borders: ["India", "Myanmar"]
  },

  "Belarus": {
    continent: "Europe",
    borders: ["Latvia", "Lithuania", "Poland", "Russia", "Ukraine"]
  },

  "Belgium": {
    continent: "Europe",
    borders: ["France", "Germany", "Luxembourg", "Netherlands"]
  },

  "Benin": {
    continent: "Africa",
    borders: ["Burkina Faso", "Niger", "Nigeria", "Togo"]
  },

  "Bhutan": {
    continent: "Asia",
    borders: ["China", "India"]
  },

  "Bolivia": {
    continent: "South America",
    borders: ["Argentina", "Brazil", "Chile", "Paraguay", "Peru"]
  },

  "Brazil": {
    continent: "South America",
    borders: ["Argentina","Bolivia","Colombia","Guyana","Paraguay","Peru","Suriname","Uruguay","Venezuela"]
  },

  "Bulgaria": {
    continent: "Europe",
    borders: ["Greece", "North Macedonia", "Romania", "Serbia", "Turkey"]
  },

  "Burkina Faso": {
    continent: "Africa",
    borders: ["Benin", "Ivory Coast", "Ghana", "Mali", "Niger", "Togo"]
  },

  "Burundi": {
    continent: "Africa",
    borders: ["DR Congo", "Rwanda", "Tanzania"]
  },

  "Cambodia": {
    continent: "Asia",
    borders: ["Laos", "Thailand", "Vietnam"]
  },

  "Cameroon": {
    continent: "Africa",
    borders: ["Central African Republic", "Chad", "Republic of the Congo", "Equatorial Guinea", "Gabon", "Nigeria"]
  },

  "Canada": {
    continent: "North America",
    borders: ["USA"]
  },

  "Chad": {
    continent: "Africa",
    borders: ["Cameroon", "Central African Republic", "Libya", "Niger", "Nigeria", "Sudan"]
  },

  "China": {
    continent: "Asia",
    borders: ["Afghanistan","Bhutan","India","Kazakhstan","North Korea","Kyrgyzstan","Laos","Mongolia","Myanmar","Nepal","Pakistan","Russia","Tajikistan","Vietnam", "Hong Kong", "Macau"]
  },

  "Colombia": {
    continent: "South America",
    borders: ["Brazil", "Ecuador", "Panama", "Peru", "Venezuela"]
  },

  "DR Congo": {
    continent: "Africa",
    borders: ["Angola","Burundi","Central African Republic","Republic of the Congo","Rwanda","South Sudan","Tanzania","Uganda","Zambia"]
  },

  "Republic of the Congo": {
    continent: "Africa",
    borders: ["Angola","Cameroon","Central African Republic","DR Congo","Gabon"]
  },

  "Ivory Coast": {
    continent: "Africa",
    borders: ["Burkina Faso", "Ghana", "Guinea", "Liberia", "Mali"]
  },

  "Czech Republic": {
    continent: "Europe",
    borders: ["Austria", "Germany", "Poland", "Slovakia"]
  },

  "Denmark": {
    continent: "Europe",
    borders: ["Germany"]
  },

  "Egypt": {
    continent: "Africa",
    borders: ["Palestine", "Israel", "Libya", "Sudan"]
  },

  "Ethiopia": {
    continent: "Africa",
    borders: ["Djibouti", "Eritrea", "Kenya", "Somalia", "South Sudan", "Sudan"]
  },

  "Finland": {
    continent: "Europe",
    borders: ["Norway", "Sweden", "Russia"]
  },

  "France": {
    continent: "Europe",
    borders: [
      "Andorra",
      "Belgium",
      "Germany",
      "Italy",
      "Luxembourg",
      "Monaco",
      "Spain",
      "Switzerland"
    ]
  },

  "Germany": {
    continent: "Europe",
    borders: [
      "Austria",
      "Belgium",
      "Czech Republic",
      "Denmark",
      "France",
      "Luxembourg",
      "Netherlands",
      "Poland",
      "Switzerland"
    ]
  },

  "Greece": {
    continent: "Europe",
    borders: ["Albania", "Bulgaria", "North Macedonia", "Turkey"]
  },

  "Guatemala": {
    continent: "North America",
    borders: ["Belize", "El Salvador", "Honduras", "Mexico"]
  },

  "Hungary": {
    continent: "Europe",
    borders: ["Austria", "Croatia", "Romania", "Serbia", "Slovakia", "Slovenia", "Ukraine"]
  },

  "India": {
    continent: "Asia",
    borders: ["Bangladesh", "Bhutan", "China", "Myanmar", "Nepal", "Pakistan"]
  },

  "Indonesia": {
    continent: "Asia",
    borders: ["Malaysia", "Papua New Guinea", "East Timor"]
  },

  "Iran": {
    continent: "Asia",
    borders: ["Afghanistan", "Armenia", "Azerbaijan", "Iraq", "Pakistan", "Turkey", "Turkmenistan"
    ]
  },

  "Iraq": {
    continent: "Asia",
    borders: ["Iran", "Jordan", "Kuwait", "Saudi Arabia", "Syria", "Turkey"]
  },

  "Ireland": {
    continent: "Europe",
    borders: ["UK"]
  },

  "Israel": {
    continent: "Asia",
    borders: ["Egypt", "Jordan", "Lebanon", "Syria", "Palestine"]
  },

  "Italy": {
    continent: "Europe",
    borders: ["Austria", "France", "San Marino", "Slovenia", "Switzerland", "Vatican City"]
  },

  "Japan": {
    continent: "Asia",
    borders: []
  },

  "Jordan": {
    continent: "Asia",
    borders: ["Iraq", "Israel", "Saudi Arabia", "Syria", "Palestine"]
  },

  "Kazakhstan": {
    continent: "Asia",
    borders: ["China", "Kyrgyzstan", "Russia", "Turkmenistan", "Uzbekistan"]
  },

  "Kenya": {
    continent: "Africa",
    borders: ["Ethiopia", "Somalia", "South Sudan", "Tanzania", "Uganda"]
  },

  "North Korea": {
    continent: "Asia",
    borders: ["China", "Russia", "South Korea"]
  },

  "South Korea": {
    continent: "Asia",
    borders: ["North Korea"]
  },

  "Kuwait": {
    continent: "Asia",
    borders: ["Iraq", "Saudi Arabia"]
  },

  "Kyrgyzstan": {
    continent: "Asia",
    borders: ["China", "Kazakhstan", "Tajikistan", "Uzbekistan"]
  },

  "Laos": {
    continent: "Asia",
    borders: ["Cambodia", "China", "Myanmar", "Thailand", "Vietnam"]
  },

  "Latvia": {
    continent: "Europe",
    borders: ["Belarus", "Estonia", "Lithuania", "Russia"]
  },

  "Lebanon": {
    continent: "Asia",
    borders: ["Israel", "Syria"]
  },

  "Lesotho": {
    continent: "Africa",
    borders: ["South Africa"]
  },

  "Liberia": {
    continent: "Africa",
    borders: ["Guinea", "Ivory Coast", "Sierra Leone"]
  },

  "Libya": {
    continent: "Africa",
    borders: ["Algeria", "Chad", "Egypt", "Niger", "Sudan", "Tunisia"]
  },

  "Lithuania": {
    continent: "Europe",
    borders: ["Belarus", "Latvia", "Poland", "Russia"]
  },

  "Luxembourg": {
    continent: "Europe",
    borders: ["Belgium", "France", "Germany"]
  },

  "Malaysia": {
    continent: "Asia",
    borders: ["Brunei", "Indonesia", "Thailand"]
  },

  "Mexico": {
    continent: "North America",
    borders: ["Belize", "Guatemala", "USA"]
  },

  "Moldova": {
    continent: "Europe",
    borders: ["Romania", "Ukraine"]
  },

  "Mongolia": {
    continent: "Asia",
    borders: ["China", "Russia"]
  },

  "Montenegro": {
    continent: "Europe",
    borders: ["Albania", "Bosnia and Herzegovina", "Croatia", "Kosovo", "Serbia"]
  },

  "Morocco": {
    continent: "Africa",
    borders: ["Algeria", "Western Sahara", "Spain"]
  },

  "Mozambique": {
    continent: "Africa",
    borders: ["Eswatini", "Malawi", "South Africa", "Tanzania", "Zambia", "Zimbabwe"]
  },

  "Myanmar": {
    continent: "Asia",
    borders: ["Bangladesh", "China", "India", "Laos", "Thailand"]
  },

  "Namibia": {
    continent: "Africa",
    borders: ["Angola", "Botswana", "South Africa", "Zambia"]
  },

  "Nepal": {
    continent: "Asia",
    borders: ["China", "India"]
  },

  "Netherlands": {
    continent: "Europe",
    borders: ["Belgium", "Germany"]
  },

  "New Zealand": {
    continent: "Oceania",
    borders: []
  },

  "Niger": {
    continent: "Africa",
    borders: ["Algeria", "Benin", "Burkina Faso", "Chad", "Libya", "Mali", "Nigeria"]
  },

  "Nigeria": {
    continent: "Africa",
    borders: ["Benin", "Cameroon", "Chad", "Niger"]
  },

  "Norway": {
    continent: "Europe",
    borders: ["Finland", "Russia", "Sweden"]
  },

    "Pakistan": {
    continent: "Asia",
    borders: ["Afghanistan", "China", "India", "Iran"]
  },

  "Peru": {
    continent: "South America",
    borders: ["Bolivia", "Brazil", "Chile", "Colombia", "Ecuador"]
  },

  "Philippines": {
    continent: "Asia",
    borders: []
  },

  "Poland": {
    continent: "Europe",
    borders: ["Belarus", "Czech Republic", "Germany", "Lithuania", "Russia", "Slovakia", "Ukraine"]
  },

  "Portugal": {
    continent: "Europe",
    borders: ["Spain"]
  },

  "Qatar": {
  continent: "Asia",
  borders: ["Saudi Arabia"]
  },

  "Romania": {
    continent: "Europe",
    borders: ["Bulgaria", "Hungary", "Moldova", "Serbia", "Ukraine"]
  },

  "Russia": {
    continent: ["Asia","Europe"],
    borders: ["Azerbaijan", "Belarus", "China", "Estonia", "Finland", "Georgia", "Kazakhstan", "North Korea", "Latvia", "Lithuania", "Mongolia", "Norway", "Poland", "Ukraine"]
  },

  "Saudi Arabia": {
    continent: "Asia",
    borders: ["Iraq", "Jordan", "Kuwait", "Oman", "Qatar", "UAE", "Yemen"]
  },

  "Senegal": {
    continent: "Africa",
    borders: ["Gambia", "Guinea", "Guinea-Bissau", "Mali", "Mauritania"]
  },

  "Serbia": {
    continent: "Europe",
    borders: ["Bosnia and Herzegovina", "Bulgaria", "Croatia", "Hungary", "Kosovo", "Montenegro", "North Macedonia", "Romania"]
  },

  "Singapore": {
    continent: "Asia",
    borders: []
    },

  "Spain": {
    continent: "Europe",
    borders: ["Andorra", "France", "Portugal", "Morocco"]
  },

  "Sweden": {
    continent: "Europe",
    borders: ["Finland", "Norway"]
  },

  "Switzerland": {
    continent: "Europe",
    borders: ["Austria", "France", "Germany", "Italy", "Liechtenstein"]
  },

  "Thailand": {
    continent: "Asia",
    borders: ["Cambodia", "Laos", "Malaysia", "Myanmar"]
  },

  "Turkey": {
    continent: ["Asia","Europe"],
    borders: ["Armenia", "Azerbaijan", "Bulgaria", "Georgia", "Greece", "Iran", "Iraq", "Syria"]
  },

  "Ukraine": {
    continent: "Europe",
    borders: ["Belarus", "Hungary", "Moldova", "Poland", "Romania", "Russia", "Slovakia"]
  },

  "UAE": {
    continent: "Asia",
    borders: ["Oman", "Saudi Arabia"]
  },

  "UK": {
    continent: "Europe",
    borders: ["Ireland"]
  },

  "USA": {
    continent: "North America",
    borders: ["Canada", "Mexico"]
  },

  "Vietnam": {
    continent: "Asia",
    borders: ["Cambodia", "China", "Laos"]
  },

  "Liechtenstein": {
  continent: "Europe",
  borders: ["Austria", "Switzerland"]
},

"Monaco": {
  continent: "Europe",
  borders: ["France"]
},

"San Marino": {
  continent: "Europe",
  borders: ["Italy"]
},

"Vatican City": {
  continent: "Europe",
  borders: ["Italy"]
},

"Syria": {
  continent: "Asia",
  borders: ["Iraq", "Jordan", "Lebanon", "Turkey", "Israel"]
},

"Yemen": {
  continent: "Asia",
  borders: ["Saudi Arabia", "Oman"]
},

"Sri Lanka": {
  continent: "Asia",
  borders: []
},

"Brunei": {
  continent: "Asia",
  borders: ["Malaysia"]
},

"South Sudan": {
  continent: "Africa",
  borders: ["Sudan", "Ethiopia", "Kenya", "Uganda", "DR Congo", "Central African Republic"]
},

"Botswana": {
  continent: "Africa",
  borders: ["Namibia", "South Africa", "Zimbabwe", "Zambia"]
},

"Zimbabwe": {
  continent: "Africa",
  borders: ["Botswana", "Mozambique", "South Africa", "Zambia"]
},

"Malawi": {
  continent: "Africa",
  borders: ["Mozambique", "Tanzania", "Zambia"]
},

"Madagascar": {
  continent: "Africa",
  borders: []
},

"Honduras": {
  continent: "North America",
  borders: ["Guatemala", "El Salvador", "Nicaragua"]
},

"El Salvador": {
  continent: "North America",
  borders: ["Guatemala", "Honduras"]
},

"Costa Rica": {
  continent: "North America",
  borders: ["Nicaragua", "Panama"]
},

"Panama": {
  continent: "North America",
  borders: ["Costa Rica", "Colombia"]
},

"Nicaragua": {
  continent: "North America",
  borders: ["Honduras", "Costa Rica"]
},

"Cuba": {
  continent: "North America",
  borders: []
},

"Jamaica": {
  continent: "North America",
  borders: []
},

"Haiti": {
  continent: "North America",
  borders: ["Dominican Republic"]
},

"Dominican Republic": {
  continent: "North America",
  borders: ["Haiti"]
},

"Trinidad and Tobago": {
  continent: "North America",
  borders: []
},

"Barbados": {
  continent: "North America",
  borders: []
},

"Papua New Guinea": {
  continent: "Oceania",
  borders: ["Indonesia"]
},

"Fiji": {
  continent: "Oceania",
  borders: []
},

"Solomon Islands": {
  continent: "Oceania",
  borders: []
},

"Vanuatu": {
  continent: "Oceania",
  borders: []
},

"Samoa": {
  continent: "Oceania",
  borders: []
},

"Tonga": {
  continent: "Oceania",
  borders: []
},

"Micronesia": {
  continent: "Oceania",
  borders: []
},

"Palau": {
  continent: "Oceania",
  borders: []
},

"Kiribati": {
  continent: "Oceania",
  borders: []
},

"Nauru": {
  continent: "Oceania",
  borders: []
},

"Tuvalu": {
  continent: "Oceania",
  borders: []
},

"Ghana": {
  continent: "Africa",
  borders: ["Burkina Faso", "Ivory Coast", "Togo"]
},

"Guinea": {
  continent: "Africa",
  borders: ["Guinea-Bissau", "Ivory Coast", "Liberia", "Mali", "Senegal", "Sierra Leone"]
},

"Guinea-Bissau": {
  continent: "Africa",
  borders: ["Guinea", "Senegal"]
},

"Rwanda": {
  continent: "Africa",
  borders: ["Burundi", "DR Congo", "Tanzania", "Uganda"]
},

"Tanzania": {
  continent: "Africa",
  borders: ["Burundi", "DR Congo", "Kenya", "Malawi", "Mozambique", "Rwanda", "Uganda", "Zambia"]
},

"Uganda": {
  continent: "Africa",
  borders: ["DR Congo", "Kenya", "Rwanda", "South Sudan", "Tanzania"]
},

"Zambia": {
  continent: "Africa",
  borders: ["Angola", "Botswana", "DR Congo", "Malawi", "Mozambique", "Namibia", "Tanzania", "Zimbabwe"]
},

"Mali": {
  continent: "Africa",
  borders: ["Algeria", "Burkina Faso", "Ivory Coast", "Guinea", "Mauritania", "Niger", "Senegal"]
},

"Sierra Leone": {
  continent: "Africa",
  borders: ["Guinea", "Liberia"]
},

"Bahrain": {
    continent: "Asia",
    borders: [] 
  },

  "Hong Kong": {
    continent: "Asia",
    borders: ["China"]
  },

  "Macau": {
    continent: "Asia",
    borders: ["China"]
  },

  "Bosnia and Herzegovina": {
    continent: "Europe",
    borders: ["Croatia", "Montenegro", "Serbia"]
  },

  "Central African Republic": {
    continent: "Africa",
    borders: ["Cameroon", "Chad", "DR Congo", "Republic of the Congo", "South Sudan", "Sudan"]
  },

  "Croatia": {
    continent: "Europe",
    borders: ["Bosnia and Herzegovina", "Hungary", "Montenegro", "Serbia", "Slovenia"]
  },

  "Ecuador": {
    continent: "South America",
    borders: ["Colombia", "Peru"]
  },

  "Estonia": {
    continent: "Europe",
    borders: ["Latvia", "Russia"]
  },

  "Eswatini": {
    continent: "Africa",
    borders: ["Mozambique", "South Africa"]
  },

  "Guyana": {
    continent: "South America",
    borders: ["Brazil", "Suriname", "Venezuela"]
  },

  "Mauritania": {
    continent: "Africa",
    borders: ["Algeria", "Mali", "Senegal", "Western Sahara"]
  },

  "Slovenia": {
    continent: "Europe",
    borders: ["Austria", "Croatia", "Italy", "Hungary"]
  },

  "Suriname": {
    continent: "South America",
    borders: ["Brazil", "Guyana"]
  },

  "Tajikistan": {
    continent: "Asia",
    borders: ["Afghanistan", "China", "Kyrgyzstan", "Uzbekistan"]
  },

  "Togo": {
    continent: "Africa",
    borders: ["Benin", "Burkina Faso", "Ghana"]
  },

  "Turkmenistan": {
    continent: "Asia",
    borders: ["Afghanistan", "Iran", "Kazakhstan", "Uzbekistan"]
  },

  "Uzbekistan": {
    continent: "Asia",
    borders: ["Afghanistan", "Kazakhstan", "Kyrgyzstan", "Tajikistan", "Turkmenistan"]
  },

  "Venezuela": {
    continent: "South America",
    borders: ["Brazil", "Colombia", "Guyana"]
  },

  "Western Sahara": {
    continent: "Africa",
    borders: ["Algeria", "Mauritania", "Morocco"]
  },

  "Chile": {
  continent: "South America",
  borders: ["Argentina", "Bolivia", "Peru"]
},

"Sudan": {
  continent: "Africa",
  borders: ["Egypt", "Eritrea", "Ethiopia", "Libya", "Chad", "Central African Republic", "South Sudan"]
},

"South Africa": {
  continent: "Africa",
  borders: ["Botswana", "Lesotho", "Mozambique", "Namibia", "Eswatini", "Zimbabwe"]
},

"Taiwan": {
  continent: "Asia",
  borders: []
},

"Paraguay": {
  continent: "South America",
  borders: ["Argentina", "Bolivia", "Brazil"]
},

"Somalia": {
  continent: "Africa",
  borders: ["Djibouti", "Ethiopia", "Kenya"]
},

"Tunisia": {
  continent: "Africa",
  borders: ["Algeria", "Libya"]
},

"Puerto Rico": {
  continent: "North America",
  borders: []
},

"Bahamas": {
  continent: "North America",
  borders: []
},

"Belize": {
  continent: "North America",
  borders: ["Mexico", "Guatemala"]
},

"Cape Verde": {
  continent: "Africa",
  borders: []
},

"Comoros": {
  continent: "Africa",
  borders: []
},

"Cyprus": {
  continent: "Asia",
  borders: []
},

"Djibouti": {
  continent: "Africa",
  borders: ["Eritrea", "Ethiopia", "Somalia"]
},

"Dominica": {
  continent: "North America",
  borders: []
},

"East Timor": {
  continent: "Asia",
  borders: ["Indonesia"]
},

"Eritrea": {
  continent: "Africa",
  borders: ["Sudan", "Ethiopia", "Djibouti"]
},

"Gabon": {
  continent: "Africa",
  borders: ["Cameroon", "Equatorial Guinea", "Republic of the Congo"]
},

"Gambia": {
  continent: "Africa",
  borders: ["Senegal"]
},

"Georgia": {
  continent: "Asia",
  borders: ["Armenia", "Azerbaijan", "Russia", "Turkey"]
},

"Grenada": {
  continent: "North America",
  borders: []
},

"Iceland": {
  continent: "Europe",
  borders: []
},

"Kosovo": {
  continent: "Europe",
  borders: ["Albania", "North Macedonia", "Montenegro", "Serbia"]
},

"Maldives": {
  continent: "Asia",
  borders: []
},

"Malta": {
  continent: "Europe",
  borders: []
},

"Marshall Islands": {
  continent: "Oceania",
  borders: []
},

"Mauritius": {
  continent: "Africa",
  borders: []
},

"North Macedonia": {
  continent: "Europe",
  borders: ["Albania", "Bulgaria", "Greece", "Kosovo", "Serbia"]
},

"Oman": {
  continent: "Asia",
  borders: ["Saudi Arabia", "UAE", "Yemen"]
},

"Saint Kitts and Nevis": {
  continent: "North America",
  borders: []
},

"Saint Lucia": {
  continent: "North America",
  borders: []
},

"Saint Vincent and the Grenadines": {
  continent: "North America",
  borders: []
},

"Sao Tome and Principe": {
  continent: "Africa",
  borders: []
},

"Seychelles": {
  continent: "Africa",
  borders: []
},

"Slovakia": {
  continent: "Europe",
  borders: ["Austria", "Czech Republic", "Hungary", "Poland", "Ukraine"]
},

"Uruguay": {
  continent: "South America",
  borders: ["Argentina", "Brazil"]
},

"Equatorial Guinea": {
  continent: "Africa",
  borders: ["Cameroon", "Gabon"]
},

"Palestine": {
  continent: "Asia",
  borders: ["Egypt", "Israel", "Jordan"]
},
};

export default geographyData